import React from 'react';

import { useTheme } from 'styled-components';

import GroupsIcon from '@mui/icons-material/Groups';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';

import { AcknowledgementRequestDetail } from 'utils/api/modules/entities/entities.types';

import { TilesRow, Tile, TileLabel, TileValue } from './styles';

interface RequestStatsTilesProps {
  request: AcknowledgementRequestDetail;
}

const RequestStatsTiles: React.FunctionComponent<RequestStatsTilesProps> = ({ request }) => {
  const theme = useTheme();

  return (
    <TilesRow>
      <Tile data-testid="ack-stat-recipients">
        <TileLabel $iconColor={theme.palette.primary.main}>
          <GroupsIcon fontSize="inherit" />
          Recipients
        </TileLabel>
        <TileValue>{request.totals.total}</TileValue>
      </Tile>
      <Tile data-testid="ack-stat-acknowledged">
        <TileLabel $iconColor={theme.palette.success.dark}>
          <CheckCircleIcon fontSize="inherit" />
          Acknowledged
        </TileLabel>
        <TileValue>{request.totals.acknowledged}</TileValue>
      </Tile>
      <Tile data-testid="ack-stat-pending">
        <TileLabel $iconColor={theme.palette.warning.dark}>
          <ScheduleIcon fontSize="inherit" />
          Pending
        </TileLabel>
        <TileValue>{request.totals.pending}</TileValue>
      </Tile>
      <Tile data-testid="ack-stat-complete">
        <TileLabel $iconColor={theme.palette.secondary.dark}>
          <DonutLargeIcon fontSize="inherit" />% Complete
        </TileLabel>
        <TileValue>{request.completionPercent}%</TileValue>
      </Tile>
    </TilesRow>
  );
};

export default RequestStatsTiles;
